export const idleTimer = {
    tokenRefreshInterval: 5,    // in minutes
    timeoutInterval: 10,        // in minutes
    warningTime: 2,             // in minutes
}